// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const FormatStrikeThrough = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M10.833 20h3.334v-5h-3.334v5zM6.667 4v2.446h4.166v3.697h3.334V6.446h4.166V4H6.667zM5 13.153h15v-1.63H5v1.63z" />
  </svg>
);

export default FormatStrikeThrough;
